import { gql } from "@apollo/client";

export default gql`
  mutation editJob($data: EditJobInput!) {
    job: editJob(data: $data) {
      id
      employerId
      unit
      floor
      locationInstruction
      workTypeId
      peopleNeeded
      hourlyRate
      street
      city
      region
      country
      description
      isActive
      breakMins
      status
      startUtc
      endUtc
      gears
      skills
      jobGear {
        gear {
          createdAt
          frenchGearName
          gearName
          id
          isActive
        }
        id
    }
    jobSkill {
        id
        skillId
        skill {
          skillName
          isActive
          frenchSkillName
          createdAt
          id
        }
    }
      isFixedTerm
      manager{
        id
        firstName
        lastName
        isActive
      }
      jobManager{
        id
        role
        managerId
        manager{
          id
          firstName
          lastName
          isActive
        }
      }
    }
  }
`;
